<button class="dark-mode-toggle" mat-icon-button (click)="toggle()">
  <mat-icon>{{ isActivated ? "brightness_4" : "brightness_5" }}</mat-icon>
</button>
